import React, { useEffect, useState } from "react"
import { Card, Container } from "react-bootstrap"
import ActionBar from "../../core/ActionBar"
import Pagination from "../../core/Pagination"
import API from "../../../common/API"
import { parsedUser } from "../../../common/GetCurrentUser"
import { useTranslation } from "react-i18next"

import Settings from "../../../common/Settings"
import Filter from "../../core/Filter/Filter"
import EmployeeValidation from "./EmployeeValidation"
import EmployeAddEdit from "../../Employees/EmployeAddEdit"

function EmployeeRequestControl() {
  const [records, setRecords] = useState([])
  const [selectedItem, setSelectedItem] = useState<any>(null)
  const [isLoading, setIsLoading] = useState(false)
  const [readOnly, setReadOnly] = useState<boolean>(false)
  const [showEmployeeValidation, setShowEmployeeValidation] = useState(false)
  const user = parsedUser()
  const { t } = useTranslation("global")
  const [filterFields, setFilterFields] = useState([
    {
      name: "responsable",
      title: "Nombre Representante",
      htmlType: "text",
      dbType: "string",

      containerClass: "col-md-6 col-lg-4 col-12",
    },
  ])
  const [showAddEdit, setShowAddEdit] = useState<boolean>(false)
  const toggleAddEdit = (item?: any) => {
    setShowAddEdit(!showAddEdit)
    setSelectedItem(item)
    if (showAddEdit) {
      bindDataRemote()
    }
  }
  const toggleEmployee = (item?: any, readonly?: boolean | undefined) => {
    setShowEmployeeValidation(!showEmployeeValidation)
    setSelectedItem(item)
    if (readonly) {
      setReadOnly(true)
    }
    if (showEmployeeValidation) {
      bindDataRemote()
    }
  }

  const bindDataRemote = async () => {
    try {
      console.log("bindDataRemote")
      setIsLoading(true)
      let query = {
        organizationId: user.OrganizationId,
      }
      const request = await API.postAction(
        "laborAccessRequest/EmployeeRequestList",
        query
      )
      if (request.data.status === "ok") {
        setRecords(request.data.response)
      }
    } catch (e) {
      console.error(e)
    } finally {
      setIsLoading(false)
    }
  }
  const approveOrDeny = async (item: any, approve: boolean) => {
    let request = await API.getAction(
      `laborAccessRequest/AproveEmployee?laborAccessRequestEmployeeId=${item.laborAccessRequestProviderId}&approve=${approve}`
    )

    bindDataRemote()
  }

  const [filterObj, setFilterObj] = useState({})
  const getFilterValues = obj => {
    console.log("obj", obj)
    setFilterObj(obj)
  }

  useEffect(() => {
    bindDataRemote()
  }, [])
  return (
    <>
      {showAddEdit && (
        <EmployeAddEdit
          toggle={toggleAddEdit}
          record={selectedItem}
          cssClass="modalRight"
          title="Plantilla de Personal"
          laborAccessRequestId={selectedItem?.laborAccessRequestId}
        />
      )}

      {showEmployeeValidation && (
        <EmployeeValidation
          toggle={toggleEmployee}
          record={selectedItem}
          readOnly={readOnly}
        />
      )}
      <Container fluid>
        <ActionBar
          title="CONTROL DE SOLICITUDES/REPRESENTANTES"
          // actions={
          //   <>
          //     <button
          //       className="btn btn-primary btn-sm me-2"
          //       type="button"
          //       onClick={() => toggleAddEdit()}
          //     >
          //       <i className="fa fa-plus " />
          //     </button>
          //   </>
          // }
        />

        <div className="my-4">
          <Filter
            title={t("Filter")}
            // toggleFilter={toggleFilter}
            fields={filterFields}
            filterAction={() => {
              bindDataRemote()
            }}
            setFilterFields={getFilterValues}
          />
        </div>

        <Card className="my-4">
          <Card.Body className="p-0">
            <div className="table-responsive">
              {records && records.length > 0 && (
                <table className="table table-striped">
                  <thead>
                    <tr>
                      {/* <th>{t("Propetary Name")}</th> */}
                      {/* <th>{t("Address")}</th> */}
                      <th>{t("Representante")}</th>
                      <th>{t("Empleado")}</th>
                      <th>{t("Estatus Empleado")}</th>
                      <th className="text-center">{t("Acceso")}</th>
                      {/* <th>{t("Segundo Responsable")}</th> */}
                      <th className="text-center">
                        {t("Estatus de Solicitud")}
                      </th>
                      {/* <th>{t("Solicitud")}</th> */}
                      {/* <th>{t("Notes")}</th> */}
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {records.map((item: any, index: number) => {
                      console.log(item)
                      return (
                        <tr key={index}>
                          {/* <td
                            onClick={() => toggleEmployee(item)}
                            className="clickable"
                          >
                            {item.propetaryName}
                          </td> */}

                          <td className="align-middle text-truncate">
                            {item.responsibleEngineerPicture && (
                              <img
                                src={`${Settings.BasePath}/files/${item.responsibleEngineerPicture}`}
                                width="50"
                                height="50"
                                className="rounded-circle me-2 "
                              />
                            )}
                            {item.responsableName ?? "-"}
                            {/* <br />
                            {!item.responsableHasWarning ? (
                              <>
                                <span className="badge bg-success ms-2">
                                  Sin ficha
                                </span>
                              </>
                            ) : (
                              <>
                                <span className="badge bg-danger ms-2">
                                  Con ficha
                                </span>
                              </>
                            )} */}
                          </td>

                          <td>
                            {item.employeeName}
                            <br />
                            <div className="btn-group">
                              {item.approved !== true && (
                                <button
                                  className="btn btn-sm btn-success "
                                  onClick={() => approveOrDeny(item, true)}
                                >
                                  <span className="fa fa-thumbs-up me-2"></span>{" "}
                                  Aprobar
                                </button>
                              )}
                              {item.approved !== false && (
                                <button
                                  className="btn btn-sm btn-danger "
                                  onClick={() => approveOrDeny(item, false)}
                                >
                                  <span className="fa fa-thumbs-down me-2"></span>{" "}
                                  Denegar
                                </button>
                              )}
                            </div>
                          </td>
                          <td>
                            {!item.employeeHasWarning ? (
                              <span className="badge badge-lg bg-success ms-2">
                                Sin ficha
                              </span>
                            ) : (
                              <span className="badge badge-lg bg-danger ms-2">
                                Fichado
                              </span>
                            )}
                          </td>
                          <td className="text-center">
                            {/* {item.approved === null && (
                              <span className="badge badge-lg bg-warning">
                                En Proceso
                              </span>
                            )} */}
                            {item.approved !== null && (
                              <span
                                className={
                                  item.approved === true
                                    ? "badge badge-lg bg-success ms-2"
                                    : "badge  badge-lg  bg-danger ms-2"
                                }
                              >
                                {" "}
                                {item.approved === true
                                  ? "Aprobado"
                                  : "Denegado"}{" "}
                              </span>
                            )}
                          </td>
                          <td className="text-center">
                            {item.approved === null ? (
                              <span className="badge badge-lg bg-warning">
                                En Proceso
                              </span>
                            ) : (
                              <span className="badge badge-lg bg-success">
                                Procesada
                              </span>
                            )}
                          </td>
                          {/* <td>
                            {item.responsableId && item.secondResponsableId ? (
                              item.secondResponsableApproved === null ||
                              item.responsableApproved === null ? (
                                <span className="badge badge-lg bg-warning">
                                  En Proceso
                                </span>
                              ) : (
                                <span className="badge badge-lg bg-success">
                                  Procesada
                                </span>
                              )
                            ) : item.responsableId &&
                              item.secondResponsableId === null ? (
                              item.responsableApproved === null ? (
                                <span className="badge badge-lg bg-warning">
                                  En Proceso
                                </span>
                              ) : (
                                <span className="badge badge-lg bg-success">
                                  Procesada
                                </span>
                              )
                            ) : null}{" "}
                            |{" "}
                            {item.responsableApproved === true ? (
                              <span className="badge badge-lg bg-success">
                                Aprobado
                              </span>
                            ) : (
                              <span className="badge badge-lg bg-danger">
                                Denegado
                              </span>
                            )}
                          </td> */}
                          {/* <td>{item.notes}</td> */}
                          <td className="text-end">
                            <div className="btn-group">
                              <button
                                className="btn btn-sm btn-primary  d-xs-none"
                                type="button"
                                onClick={() => {
                                  toggleEmployee(item)
                                }}
                              >
                                <i className="fa fa-eye me-2" />
                                Ver solicitud
                              </button>
                            </div>
                          </td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              )}
            </div>
          </Card.Body>
        </Card>
        <Pagination
          totalPages={1}
          currentPage={0}
          onPageChanged={() => {
            console.log("onPageChanged")
          }}
        />
      </Container>
    </>
  )
}

export default EmployeeRequestControl
